<template>
<v-row>
</v-row>
</template>

<script>
// @ is an alias to /src

  export default {
    data: () => ({
      dialog: false,
    }),


    components:{
    }
  }
</script>

